import React, { useState } from "react";
import styled from "styled-components";
import { Grid, Card, CardMedia, Modal, Box, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import YouTube from "react-youtube";
import CategoryTitle from "./CategoryTitle";

const StyledCard = styled(Card)`
  height: 100%;
  display: flex;
  flex-direction: column;
  cursor: pointer;
  transition: transform 0.3s ease-in-out;
  &:hover {
    transform: scale(1.05);
  }
`;

const StyledCardMedia = styled(CardMedia)`
  padding-top: 56.25%; // 16:9 aspect ratio
`;

const ModalContent = styled(Box)`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 90%;
  max-width: 800px;
  background-color: ${(props) => props.theme.palette.background.paper};
  border: 2px solid ${(props) => props.theme.palette.primary.main};
  box-shadow: 24px;
  padding: 16px;

  @media (max-width: 600px) {
    width: 95%;
    padding: 8px;
  }
`;

const StyledYouTube = styled(YouTube)`
  width: 100%;
  height: auto;
  aspect-ratio: 16 / 9;
`;

const VideoSection = ({ name, videos }) => {
  const [selectedVideo, setSelectedVideo] = useState(null);

  const handleVideoClick = (videoId) => {
    setSelectedVideo(videoId);
  };

  const handleCloseModal = () => {
    setSelectedVideo(null);
  };

  const opts = {
    width: "100%",
    height: "100%",
    playerVars: {
      autoplay: 1,
    },
  };

  return (
    <>
      <CategoryTitle>{name}</CategoryTitle>
      <Grid container spacing={2}>
        {videos.map((videoId) => (
          <Grid item xs={12} sm={6} md={4} lg={3} key={videoId}>
            <StyledCard onClick={() => handleVideoClick(videoId)}>
              <StyledCardMedia
                image={`https://img.youtube.com/vi/${videoId}/0.jpg`}
                title="Video thumbnail"
              />
            </StyledCard>
          </Grid>
        ))}
      </Grid>
      <Modal
        open={Boolean(selectedVideo)}
        onClose={handleCloseModal}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <ModalContent>
          <IconButton
            aria-label="close"
            onClick={handleCloseModal}
            sx={{
              position: "absolute",
              right: 8,
              top: 8,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <CloseIcon />
          </IconButton>
          {selectedVideo && (
            <StyledYouTube videoId={selectedVideo} opts={opts} />
          )}
        </ModalContent>
      </Modal>
    </>
  );
};

export default VideoSection;
